import React, { FC, Fragment } from 'react';

import Border from '../atoms/Border/Border';
import Box from '../atoms/Box/Box';
import { Col, Row } from '../atoms/Grid';
import AccountTitle from '../molecules/AccountTitle';
import AvailablePlatforms from '../molecules/AvailablePlatforms';
import SubscriptionInfo from '../molecules/SubscriptionInfo/SubscriptionInfo';
import SubscriptionsAd from '@components/organisms/SubscriptionsAd';

import { GroupedPlatforms } from '@shared/interfaces/grouped-platforms';
import { I18nTranslation } from '@shared/interfaces/i18n';
import { SUBSCRIPTION_ICONS } from '@shared/markup/constants';

import moment from 'moment';
import { withTranslation } from 'i18n';

type PurchasedPlatformsProps = {
  groupedPlatforms?: GroupedPlatforms;
  formattedApplications?: Record<string, string>;
  t: I18nTranslation;
};

const PurchasedPlatforms: FC<PurchasedPlatformsProps> = ({
  groupedPlatforms,
  formattedApplications,
  t: tProp,
}) => {
  const t = key => tProp(`platforms.${key}`);

  return (
    <Fragment>
      <AccountTitle>{t('title')}</AccountTitle>
      {Object.keys(groupedPlatforms).map(appId => {
        const appIdNumber = +appId;
        const appName = formattedApplications[appIdNumber];
        const platforms = groupedPlatforms[appIdNumber];
        const timestamps = platforms.map(platform =>
          moment(platform.createdTimestamp)
        );
        const minTimestamp = moment.min(timestamps).toJSON();

        return (
          <Box key={appId} mb={4}>
            <Border>
              <Row>
                <Col xs={12} sm={6}>
                  <SubscriptionInfo
                    hasExpired={false}
                    appName={appName}
                    licenseImage={SUBSCRIPTION_ICONS.individual}
                    licenseName={t('individual')}
                    purchasedDate={minTimestamp}
                    format="D MMM YYYY"
                    extraComponent={() => (
                      <AvailablePlatforms
                        title={t('available')}
                        platforms={platforms}
                      />
                    )}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <SubscriptionsAd />
                </Col>
              </Row>
            </Border>
          </Box>
        );
      })}
    </Fragment>
  );
};

export default withTranslation('account')(PurchasedPlatforms);
